import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import {
  billCreditSystemInfoActiveWorkflowsTable,
  billCreditSystemInfoWorkflowHistoryTable,
  commonSystemNotesTable,
  customersClientsAccessTable,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { Stack } from "@mui/material";
import { GridComp6 } from "../../../components/GridComponents";
import { CustomCheckBoxComp126 } from "../../../components/CheckboxComp";
import { getTransactionActiveAndWorkFlow, getTransactionShippingAddress } from "../../../api/transaction-type";

export default function CustomWorkflow() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  // useEffect(() => {
  //   if (user.token) {
  //     getTransactionShippingAddressData();
  //   }
  // }, []);
  async function getTransactionActiveAndWorkFetch(limit,offset) {
 
    try {
      const { data } = await getTransactionActiveAndWorkFlow(user.token, {
        id: params.docNo,
        limit:limit,
        offset:offset,
        type:tabIndex === 0 ? "active"  :"history",
      });
      
      return { rows: data.data.items, total: data.data.itemstotal, error: false };
    } catch (error) {
      console.log(error);
      
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      
    }
  }
  return (
    <>
      <Box>
        <Box
          className="sub-tab"
          sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
           
            <Tab label="Active Workflows" />
            <Tab label="Workflow History" />
          </Tabs>

          {/* Active Workflows */}
         {tabIndex === 0 && <TabPanel value={tabIndex} index={0}>
            <Box className="viewDetilsBox">
              <Grid container spacing={2}>
                <Grid item xs={8} sm={6} md={3} className="m-b-10">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="list">Default</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            <AgGridPaginatedTable
              getTableRows={getTransactionActiveAndWorkFetch}
              columns={billCreditSystemInfoActiveWorkflowsTable}
              perPage={5}
              refreshCounter={0}
            />
          </TabPanel>}
          {/* Active Workflows */}

          {/* Workflow History  */}
          {tabIndex ===1 &&<TabPanel value={tabIndex} index={1}>
            <Box className="viewDetilsBox">
              <Grid container spacing={2}>
                <Grid item xs={8} sm={6} md={3} className="m-b-10">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="list">Default</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            <AgGridPaginatedTable
              getTableRows={getTransactionActiveAndWorkFetch}
              columns={billCreditSystemInfoWorkflowHistoryTable}
              perPage={5}
              refreshCounter={0}
            />

          </TabPanel>}
          {/* Workflow History  */}
        </Box>
      </Box>
    </>
  );
}
